import React, { useState } from 'react';
import LogoBarberia from '../../assets/LogoBarbearia.png';
import insta from '../../assets/insta.png';
import './pageBarber.css';
import { Link } from 'react-router-dom';

export default function PageBarber() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    }
    return (
        <div>
            {/* Navegação */}
            <nav className="navigation">
                <img src={LogoBarberia} alt="Logo" className="logo" />
                <button className="menu-btn" onClick={toggleMenu}>☰</button>
                <ul className={`nav-list ${menuOpen ? 'show' : 'hidden'}`}>
                    <li><a href="#home">Início 💈</a></li>
                    <li><a href="#contato">Contato 💈</a></li>
                    <li><a href="#info">Mais informações 💈</a></li>
                </ul>
                <Link to="/loginCli" className="book-now">Agende agora</Link>
            </nav>
            <div className='line'> </div>

            {/* Introdução */}
            <div className="videoWrapper">
            <img src={LogoBarberia} alt="Logo" className="imgback" />
                <div className="darkOverlay"></div>
                <div className="overlayText">
                    💈Corte's curte💈

                    <Link to="/loginCli" className="book-now">AgendeAgora</Link>
                </div>
            </div>
            <div className='line'> </div>

            <h1 className='title'>BARBEARIA CORTE'S CURTE</h1>

            {/* Serviços oferecidos */}
            <div id="contato" className="buttonContainer">
                <div className="buttonsWrapper">
                    <a className="contato" href="https://www.google.com/maps/place/R.+Nossa+Sra.+da+Boa+Viagem,+928+-+Ferraz%C3%B3polis,+S%C3%A3o+Bernardo+do+Campo+-+SP,+09781-020/@-23.724892,-46.538182,15z/data=!4m6!3m5!1s0x94ce41be3206a035:0x2df5faeb6d9f9dc5!8m2!3d-23.7248917!4d-46.5381822!16s%2Fg%2F11c2ck5lrl?hl=en&entry=ttu&g_ep=EgoyMDI1MDYxNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
                        Endereço
                    </a>
                    <a className="contato" href="https://wa.me/5511949856225" target="_blank" rel="noopener noreferrer">
                        WhatsApp
                    </a>
                    <Link to="/loginCli" className="contato">Agende agora</Link>
                </div>
                <img src={LogoBarberia} alt="Logo" className="logoSide" />
            </div>

            <div className='line'> </div>
            {/* Rodapé */}
            <footer id="info">
                <div className="footer-content">
                    <div className="footer-section">
                        <h4>Horários</h4>
                        <p>Segunda</p>
                        <p>09:00 às 19:00</p>
                        <p>Terça</p>
                        <p>08:00 às 19:00</p>
                        <p>Quarta</p>
                        <p>09:00 às 19:00</p>
                        <p>Quinta</p>
                        <p>08:00 às 19:00</p>
                        <p>Sexta</p>
                        <p>07:00 às 19:00</p>
                        <p>Sábado</p>
                        <p>07:00 às 19:00</p>
                        <p>Domingo</p>
                        <p>Fechado</p>
                    </div>
                    <div className="footer-section">
                        <h4>Siga-nos no Instagram</h4>
                        <a href='https://www.instagram.com/cortescurte/' target="_blank" rel="noopener noreferrer">
                            <img src={insta} alt="Instagram Logo" className="instagram-logo" />
                        </a>
                    </div>
                    <div className="footer-section">
                        <iframe
                            title="Mapa do Corte's Curte Jē"  // Adicionado um título
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.630331193337!2d-46.5381822!3d-23.724891700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce41be3206a035%3A0x2df5faeb6d9f9dc5!2sR.%20Nossa%20Sra.%20da%20Boa%20Viagem%2C%20928%20-%20Ferraz%C3%B3polis%2C%20S%C3%A3o%20Bernardo%20do%20Campo%20-%20SP%2C%2009781-020!5e0!3m2!1sen!2sbr!4v1714698460775!5m2!1sen!2sbr"
                            width="300"
                            height="150"
                            style={{ border: '0' }}  // Estilo corrigido
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade">
                        </iframe>
                        <address>
                            R. Nossa Sra. da Boa Viagem, 928 <br />
                            Ferrazópolis, São Bernardo do Campo - SP<br />
                            09781-020<br />
                        </address>
                        <p>CORTE'S CURTE BARBEARIA</p>
                        <p>Todos os direitos reservados.</p>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>Copyright © 2023. CORTE'S CURTE. Todos os direitos reservados.</p>
                </div>
            </footer>

        </div>
    );
}
